"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTestData = filterTestData;
exports.filterSeoBannedUsers = filterSeoBannedUsers;
exports.filterSeoBannedOrganizations = filterSeoBannedOrganizations;
const shared_1 = require("@buildwithflux/shared");
const adapters_1 = require("../adapters");
/**
 * Function to generate filter string for test_data, taking searchProvider
 * into account
 */
function filterTestData(and, searchProvider) {
    if ((0, shared_1.isProductionEnvironment)()) {
        if (and) {
            return `${(0, adapters_1.normalizedAndOperator)(searchProvider)} test_data:false`;
        }
        return `test_data:false`;
    }
    return "";
}
function filterSeoBannedUsers(and, searchProvider) {
    // Filter out both SEO-banned users and soft-deleted users (seo: "removed")
    if (and) {
        return `${(0, adapters_1.normalizedAndOperator)(searchProvider)} seo:!=banned ${(0, adapters_1.normalizedAndOperator)(searchProvider)} seo:!=removed`;
    }
    return `seo:!=banned && seo:!=removed`;
}
function filterSeoBannedOrganizations(and, searchProvider) {
    if (and) {
        return `${(0, adapters_1.normalizedAndOperator)(searchProvider)} seo:!=banned`;
    }
    return `seo:!=banned`;
}
//# sourceMappingURL=general.js.map